// SPDX-FileCopyrightText: Copyright 2025 OP Financial Group (https://op.fi). All Rights Reserved.
//
// SPDX-License-Identifier: LicenseRef-OpAllRightsReserved

import React from 'react';
import { Action } from '@op/opds.opux';

interface TupasButtonProps {
    name: string;
    image: string;
    onClick: () => void;
}

const TupasButton: React.FC<TupasButtonProps> = ({ name, image, onClick }) => {
    const handleKeyDown = (event: React.KeyboardEvent<HTMLDivElement>): void => {
        if (event.code === 'Space' || event.code === 'Enter') {
            event.preventDefault();
            onClick();
        }
    };

    return (
        <div // NOSONAR
            role="button"
            className="opux-g-col-xs-6 opux-g-col-s-4 opux-tupas-btn tupas-table-btn"
            onClick={onClick}
            onKeyDown={handleKeyDown}
            data-testid="tupas-button"
            tabIndex={0}
        >
            <Action inline className="opux-tooltip" data-tooltip={name}>
                <img src={image} alt={name} />
            </Action>
        </div>
    );
};

export default TupasButton;
